export default __webpack_public_path__ + "static/media/4.e1c8cd3a.png";